import makeStyles from '@mui/styles/makeStyles';

import { Theme } from '../../../../../../types';
import { MIN_ACTION_WIDTH } from '../../ServicesSection/serviceSectionStyles';

const generatePdfStyle = makeStyles((theme: Theme) => ({
    minHeight300px: {
        minHeight: '300px'
    },
    minHeight400px: {
        minHeight: '400px'
    },
    minHeight440px: {
        minHeight: '440px'
    },
    minHeight530px: {
        minHeight: '530px'
    },
    gridGap1: {
        gridGap: theme.spacing(1)
    },
    gridGap2: {
        gridGap: theme.spacing(2)
    },
    gridGap0_2: {
        gridGap: theme.spacing(0, 2)
    },
    heightFitContent: {
        height: 'fit-content'
    },
    maxWidth800px: {
        maxWidth: '800px'
    },
    checkboxStyle: {
        height: 'fit-content',
        margin: 'auto 0',
        paddingRight: theme.spacing(1),
        transition: 'background-color 0.3s',
        '&:hover': {
            backgroundColor: theme.palette.grey[100]
        }
    },
    marginAutoAuto0: {
        margin: 'auto auto 0'
    },
    paddingTopBottom2: {
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2)
    },
    paddingTop2: {
        paddingTop: theme.spacing(2)
    },
    paddingBottom2: {
        paddingBottom: theme.spacing(2)
    },
    radioFormControlStyle: {
        margin: 0,
        width: '100%',
        paddingRight: theme.spacing(2),
        transition: 'background-color 0.3s',
        '&:hover': {
            backgroundColor: theme.palette.grey[100]
        }
    },
    gridBorder: {
        border: '1px solid',
        borderColor: theme.palette.grey[400],
        borderRadius: '4px',
        padding: theme.spacing(2, 1)
    },
    width100: {
        width: '100%'
    },
    minWidthMaxContent: {
        minWidth: 'max-content'
    },
    flexGrow1: {
        flexGrow: 1
    },
    width160px: {
        width: '160px'
    },
    minWidth160px: {
        minWidth: '160px'
    },
    padding2px: {
        padding: '2px'
    },
    padding1_0: {
        padding: theme.spacing(1, 0)
    },
    wrapDown700px: {
        flexWrap: 'nowrap',
        ['@media (max-width:1000px)']: {
            flexWrap: 'wrap'
        }
    },
    colorError: {
        color: theme.palette.error.main
    },
    linkButton: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        }
    },
    marginLeft1Top2: {
        margin: theme.spacing(2, 0, 0, 1)
    },
    widthFitContent: {
        width: 'fit-content'
    },
    maxWidthUnset: {
        maxWidth: 'unset'
    },
    positionRelative: {
        position: 'relative'
    },
    marginLeft1: {
        marginLeft: theme.spacing(1)
    },
    minWidth180px: {
        minWidth: '180px'
    },
    minWidth90px: {
        minWidth: '90px'
    },
    marginTop0: {
        marginTop: 0
    },
    orderFirstColPadding: {
        '& .MuiTableRow-root': {
            '& .MuiTableCell-root:first-of-type': {
                padding: theme.spacing(0, 0.5, 0, 1)
            }
        }
    },
    tableWrapperDetailPanelStyle: {
        margin: theme.spacing(0, 1, 2, 0),
        '& .MuiTableRow-root': {
            '& .MuiTableCell-root:last-child': {
                minWidth: `${MIN_ACTION_WIDTH}px !important`,
                padding: 0
            }
        }
    },
    padding3px: {
        padding: '3px'
    },
    tooltipBorderStyle: {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        border: '2px solid',
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.grey[200],
        position: 'relative'
    },
    marginTop8px: {
        marginTop: '8px'
    },
    multilinePadding1_2: {
        '& .MuiOutlinedInput-multiline': {
            padding: theme.spacing(1, 2)
        }
    },
    height100percentMinus10px: {
        height: 'calc(100% - 10px)'
    },
    colorPrimary: {
        '&.MuiTextField-root': {
            '& .MuiInputLabel-outlined': {
                color: theme.palette.primary.main
            }
        }
    }
}));

export default generatePdfStyle;
